function getConsoleMethod(level) {
    switch (level) {
        case 'debug':
            return console.debug;
        case 'info':
        case 'notice':
            return console.info;
        case 'warning':
            return console.warn;
        case 'error':
        case 'critical':
        case 'alert':
        case 'emergency':
            return console.error;
        default:
            return console.log;
    }
}
// Levels that get forwarded to main via IPC and end up in the fs log / Sentry / PostHog.
// debug+info are intentionally excluded: at DEBUG verbosity the renderer emits ~12 lines/min
// per BrowserWindow which fills /var/log on log2ram-equipped devices and triggers
// log-cleanup escalation. They still go to the renderer console (DevTools) for local dev.
const IPC_FORWARDED_LEVELS = new Set(['notice', 'warning', 'error', 'critical', 'alert', 'emergency']);
// Gated behind the `.renderer` marker: debug+info are excluded by default to keep
// the IPC/file firehose off; this widens the set on demand for SSH diagnostics.
export function enableVerboseForwarding() {
    IPC_FORWARDED_LEVELS.add('debug');
    IPC_FORWARDED_LEVELS.add('info');
}
function log(level, message, context) {
    const timestamp = new Date().toISOString().split('T')[1];
    const prefix = `[${timestamp}] [${level.toUpperCase()}]`;
    const formattedMessage = `${prefix} [Renderer] ${message}`;
    const consoleMethod = getConsoleMethod(level);
    context ? consoleMethod(formattedMessage, context) : consoleMethod(formattedMessage);
    if (IPC_FORWARDED_LEVELS.has(level) && window.electronAPI?.logging?.sendLog) {
        window.electronAPI.logging.sendLog({ level, message, context, timestamp });
    }
}
export const rendererLogger = {
    debug: (message, context) => log('debug', message, context),
    info: (message, context) => log('info', message, context),
    notice: (message, context) => log('notice', message, context),
    warn: (message, context) => log('warning', message, context),
    error: (message, context) => log('error', message, context),
    critical: (message, context) => log('critical', message, context),
    log,
};
//# sourceMappingURL=logger.js.map